<template>
  <div class="text-center">
    <font-awesome-icon icon="exclamation-triangle" size="6x" class="text-lightblue"/>
    <h3 class="m-3">No Deals Found</h3>
    <verification-user-email
      v-if="!user.verified"
      ref="verificationUserAlert"
      placement="top"
      :target="buttonId"
    />
    <b-button
      :id="buttonId"
      @click="toSubmitNewDeal"
      class="btn-anchor"
    >
      SUBMIT NEW LOAN
    </b-button>
  </div>
</template>


<script>
import VerificationUserEmail from '@/components/utils/verification/VerificationUserEmail';

export default {
  components: {
    VerificationUserEmail,
  },
  data: () => ({
    buttonId: 'submit-new-deal-btn',
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    toSubmitNewDeal() {
      if (!this.user.verified) { return; }
      this.$router.push({ name: 'NewDeal' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/deals/NoDealsFound.vue